'use strict';

import React from 'react';
import {h, Fragment} from 'preact';
import ItemDesktop from './Item/Desktop';
import ItemMobile from './Item/Mobile';

export default function GoodPreview(props) {
    if (global.config.isMobile) {
        return <ItemMobile {...props} />;
    }

    return <ItemDesktop {...props} />;
}
